import { AppSchema, Database } from '@/features/powersync/generated/schema';
import { ApolloPowerSyncConnector } from '@/lib/powersync/connector';
import { wrapPowerSyncWithKysely } from '@powersync/kysely-driver';
import { env } from '@/lib/env';
import { PowerSyncLogLevel } from '@/lib/powersync/log-level';

export const createPowerSync = async () => {
  const {
    LogLevel,
    createBaseLogger: createWebLogger,
    PowerSyncDatabase: PowerSyncDatabaseWeb,
    WASQLiteOpenFactory,
  } = require('@powersync/web/umd');
  const logger = createWebLogger();

  // Configure the logger to use the default console output
  logger.useDefaults();

  // Log at the environment's level (EXPO_PUBLIC_LOG_LEVEL, shared with the app
  // logger) rather than a hardcoded DEBUG — release builds default to WARN.
  // Available levels: DEBUG, INFO, WARN, ERROR, TRACE, OFF
  logger.setLevel(LogLevel[PowerSyncLogLevel.resolveName(env.logLevel)]);

  const factory = new WASQLiteOpenFactory({
    dbFilename: 'sqlite.db',
    worker: '/@powersync/worker/WASQLiteDB.umd.js',
  });
  const powersync = new PowerSyncDatabaseWeb({
    schema: AppSchema,
    database: factory,
    sync: {
      worker: '/@powersync/worker/SharedSyncImplementation.umd.js',
    },
    logger,
  });
  // Don't connect here - let the provider handle connection based on auth state
  await powersync.init();
  return {
    powerSyncDb: powersync,
    db: wrapPowerSyncWithKysely<Database>(powersync),
  };
};
